import ButtonChangeStatus from '@app/components/ButtonChangeStatus'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { STATUS } from '@app/constant/StatusConstant'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import EditIcon from '@mui/icons-material/Edit'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export default function EmployeeIndex({ employee }) {
  const { t } = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('EMPLOYEE.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'phone',
              Header: t('EMPLOYEE.PHONE'),
              accessor: 'phone',
              type: 'string',
            },
            {
              id: 'status',
              Header: t('EMPLOYEE.STATUS'),
              accessor: ({ status }) => t(`EMPLOYEES.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: STATUS.ACTIVE, name: t('EMPLOYEE.ACTIVE') },
                { value: STATUS.IN_ACTIVE, name: t('EMPLOYEE.INACTIVE') },
              ],
              Cell: ({ row }) => (
                <ButtonChangeStatus
                  handleSubmit={() => {
                    Inertia.post(
                      route('merchant.employees.status.change', {
                        employee: row.original.id,
                      }),
                      {
                        status: row.original.status,
                      },
                      {}
                    )
                  }}
                  row={row}
                  tableName={t('EMPLOYEE.EMPLOYEE_TABLE')}
                />
              ),
            },
            {
              id: 'actions',
              Header: t('EMPLOYEE.ACTIONS'),
              align: 'center',
              cell: {
                style: { whiteSpace: 'nowrap' },
              },
              disableFilters: true,
              Cell: ({ row }) => (
                <IconButton component={InertiaLink} href={route('merchant.employees.edit', row.original.id)}>
                  <EditIcon />
                </IconButton>
              ),
            },
          ]}
          data={employee}
          enableCollapseFilter={false}
          routeName="merchant.employees.index"
        />
      </Grid>
    </Grid>
  )
}
